import {
	TextBodyExtraExtraSmall,
	TextBodySmall,
} from '@/components/text/Texts';
import IdGeneratorService from '@/services/id-generator.service';
import { isEmpty } from 'lodash';
import type { CheckboxProps } from 'primereact/checkbox';
import { Checkbox } from 'primereact/checkbox';
import type { ReactNode } from 'react';
import { Controller } from 'react-hook-form';

import Container, { Column, Row } from '../container/Container';
import styles from './checkbox-input.module.css';
import './form-input.styles.css';
import { cn } from '../ui/cn';

type Props = Partial<CheckboxProps> & {
	checked?: boolean;
	children?: ReactNode;
	className?: string;
	rowClassName?: string;
	color?: string;
	containerClassName?: string;
	// biome-ignore lint/suspicious/noExplicitAny: Control will have different structure on each use of the TextInput
	control: any;
	formName?: string;
	id: string;
	text?: string;
	textEl?: React.ReactNode;
	primeCheckboxProps?: any;
};

const CheckboxInput = ({
	children,
	className = '',
	rowClassName = '',
	color = '',
	containerClassName = '',
	control,
	formName,
	id,
	text,
	textEl,
	primeCheckboxProps,
	...props
}: Props) => {
	const idService = new IdGeneratorService(formName);
	const idGenerated = isEmpty(formName)
		? idService.generateCheckboxIds(id)
		: idService.generateFormCheckboxIds(id);
	return (
		<Container className={`flex ${containerClassName}`}>
			<Controller
				control={control}
				name={id}
				render={({ field, fieldState: { error } }) => {
					const resolvedChecked = (props as any).checked ?? field.value;
					const handleChange = (e: any) => {
						(props as any).onChange?.(e);
						field.onChange(e.checked);
					};

					return (
						<Row className={rowClassName}>
							<Checkbox
								{...props}
								className={cn('self-center', className)}
								data-testid={idGenerated.testId}
								inputId={idGenerated.id}
								pt={(props as any).pt ?? { box: { className: styles.defaultCheckboxInput } }}
								onChange={handleChange}
								checked={resolvedChecked}
								variant="outlined"
								{...primeCheckboxProps}
							/>
							<Column>
								{children ?? ((text || textEl) && (
									<label
										htmlFor={idGenerated.id}
										className="pl-[12px] align-middle self-center"
										children={textEl ?? (<TextBodySmall text={text ?? idService.generateLabel(id)} className={cn('align-middle', color)} />)}
									/>
								))}
								{(!isEmpty(error) && error.message) ? (
									<TextBodyExtraExtraSmall
										id={`${idGenerated.id}-helper`}
										className="block pl-[16px] mt-1 text-error"
										text={error.message ?? ''}
									/>
								) : (
									''
								)}
							</Column>
						</Row>
					);
				}}
			/>
		</Container>
	);
};

export default CheckboxInput;
